import { Injectable } from '@angular/core';
import { LoadingService } from '../loading-spinner/loading.service';
import { HttpClient } from '@angular/common/http';
import { AnswerFromSimple } from '../answer-from-simple';


@Injectable({
    providedIn: 'root'
})
export class PaymentstatusService {
    constructor(private _http: HttpClient, private _loadingService: LoadingService) {}

    showLoadingScreen() {
        this._loadingService.show();
    }
}
